import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IDisease } from 'src/app/shared/interfaces/disease';
import { EDiseaseType } from 'src/app/shared/interfaces/diseaseType-enum';
import { EGender } from 'src/app/shared/interfaces/gender-enum';
import { IUser } from 'src/app/shared/interfaces/user';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-patient-profile',
  templateUrl: './patient-profile.component.html',
  styleUrl: './patient-profile.component.css',
  standalone: false
})
export class PatientProfileComponent implements OnInit {

  userId: any;
  genderType = EGender;
  diseaseType = EDiseaseType;
  allDisease: IDisease[] = [];
  allSurgery: IDisease[] = [];
  selectedDiseases: number[] = [];
  userInfo: IUser = {
    id: 0,
    userInfoId: 0,
    firstName: '',
    lastName: '',
    mobile: '',
    mail: '',
    status: 0, //enum
    idNo: '',
    birthDate: 0, //date time
    isMale: true,
    education: '',
    job: '',
    country: '',
    state: '',
    city: '',
    zipCode: '',
    address: '',
    smsCode: '',
    lastDrug: '',
    lastAllergy : '',
    skyRoomPassword: '',
    gender: 0, //Gender
    skyRoomUserId: 0,
    photoFileName: '',
    IsActiveOnlineVisit: false,
    IsActiveAttendanceVisit: false,
    userDiseases: []
    
  };

  constructor(
    private location: Location,
    private apiService: ApiService,
    private route: ActivatedRoute
  ){}


  ngOnInit(): void {
    this.userId = this.route.snapshot.params.id;

    this.getPatientDetail();
  }

  back(): void {
    this.location.back()
  }

  onDateSelected(date: string) {
    console.log('Selected date:', date);
  }

  getPatientDetail() {
    this.apiService.apiCall('get', '/api/User/Detail/' + this.userId).subscribe((res: any) => {
      console.log(res);
      this.userInfo = res.body.model;
      
    })
  }
}
